// Main entry point for TaskManagement module
import TaskManagement from './pages/TaskManagement.js';
export default TaskManagement;
